exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CN8b_H-vp26NxjABwwT7a{white-space:nowrap;color:\"[theme:redDark, default:#a80000]\";font-weight:400}html[dir=ltr] .rK3aivbMQMOCkH0WcMu-q{margin-right:10px}html[dir=rtl] .rK3aivbMQMOCkH0WcMu-q{margin-left:10px}", ""]);
// Exports
exports.locals = {
	"couponRow": "CN8b_H-vp26NxjABwwT7a",
	"icon": "rK3aivbMQMOCkH0WcMu-q"
};